export const environment = {
    production: true,
    // url: 'https://dev.exevirtual.com',
    url: '/api',
    path: '.'
};
